export default "__VITE_ASSET__83a3919f__"